<template>
  <div>
    <!-- <v-list class="xs12" three-line>
      <template v-for="ap in artwork_texts">
        <v-list-tile :key="ap.id+ 'text'">
          <v-list-tile-content>
    <v-list-tile-title> {{ap.title}}</v-list-tile-title>-->
    <!-- <v-list-tile-sub-title>
              <span class='text--primary'> {{ap.artwork_location_id}}</span>
              <span v-if="ap.text" class='text--primary'>Loc: {{get_location_name(ap)}} </span>
    </v-list-tile-sub-title>-->
    <!-- </v-list-tile-content>
        </v-list-tile>
        <v-divider :key="'a'+ap.id"></v-divider>
      </template>
    </v-list>-->

    <!-- bio -->
    <v-container class="my-0 mx-0 px-0 py-0" fluid>
      <!-- v-if="this.artwork.bibliography_details" -->
      <v-layout class="my-0 mx-2 px-0 py-0" row wrap>
        <v-card class="my-0 mx-2" style="width: 100%">
          <v-card-title class="pb-0 mb-0">
            <span class="headline">Bibliography Details</span>
          </v-card-title>

          <v-card-text
            class="py-0 my-0 bio"
            v-if="!edit_bio_dialog"
            v-html="
              this.artwork.bibliography_details != null
                ? this.artwork.bibliography_details
                : 'No text filled-in yet'
            "
          ></v-card-text>

          <v-dialog v-model="edit_bio_dialog" width="80%">
            <v-card elevation-2 mx-3 mt-4 style="width: 100%">
              <v-container grid-list-xs fluid>
                <v-layout row wrap>
                  <!-- <v-card-text v-if="edit_bio_dialog"> -->
                  <text-editor
                    @input="bibliography_details = $event"
                    :value="bibliography_details"
                  ></text-editor>
                  <v-layout class="pl-3 pb-3 mt-2 justify-end">
                    <v-spacer></v-spacer>
                    <v-btn flat @click="edit_bio_dialog = false">cancel</v-btn>
                    <v-btn dark @click="save_bio">save</v-btn>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card>
          </v-dialog>

          <v-card-actions class="mx-1">
            <v-spacer></v-spacer>
            <v-btn @click="copy2c(artwork.bibliography_details)" small icon>
              <v-icon small>file_copy</v-icon>
            </v-btn>
            <!-- <v-btn small icon class="mr-3">
              <v-icon small>file_copy</v-icon>
            </v-btn> -->
            <v-btn @click="download_text(p)" small icon class="mr-1">
              <v-icon small color="black">mdi-download</v-icon>
            </v-btn>
            <v-btn
              @click="edit_bio()"
              small
              icon
              class="mr-0"
              v-if="c_user.edit"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <v-btn
              @click="delete_text(p)"
              small
              icon
              class="mr-1"
              v-if="c_user.delete_rights"
            >
              <v-icon color="red" small>delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-container>

    <div>
      <!-- <h3 class="mt-5 pl-3">Uploaded text files</h3> -->
      <upload
        :artwork="artwork"
        class="xs12 mx-0 px-0 mt-5"
        style="width: 100%"
        :field="{ title: 'Text uploads' }"
        uploadCategory="artwork_literature"
      ></upload>
    </div>

    <!-- add form -->
    <div v-if="add_text">
      <!-- <v-btn
        class="right primary mt-4 mr-3 mb-0 xs12"
        v-if="!showUpload"
        @click="showUpload=!showUpload"
      >Add text</v-btn> -->
      <!-- <v-btn class="right primary mt-4 mr-3 mb-0 xs12" v-if="showUpload" @click="showUpload=!showUpload">close</v-btn> -->
      <v-flex v-if="showUpload" elevation-2 mx-3 mt-4>
        <v-container grid-list-xs fluid>
          <v-layout row wrap>
            <v-text-field
              v-model="text.title"
              class="flex xs12 ml-2"
              name="Title"
              label="Title"
            ></v-text-field>
            <text-editor @input="text.content = $event"></text-editor>
            <!-- <div class="editor xs12">
              <editor-menu-bar :editor="editor">
                <div slot-scope="{ commands, isActive }">
                  <button :class="{ 'is-active': isActive.bold() }" @click="commands.bold">
                    Bold
                  </button>
                  <button :class="{ 'is-active': isActive.italic() }" @click="commands.italic">
                    Italic
                  </button>
                  <button :class="{ 'is-active': isActive.heading({ level: 2 }) }" @click="commands.heading({ level: 2 })">
                    H2
                  </button>
                </div>
              </editor-menu-bar>
              <editor-content class="xs12 editor__content" v-model="text.content" :editor="editor" />
            </div>{{editor.content}}test-->
            <!-- <v-textarea v-model="text.content" auto-grow  class="flex xs12 ml-2" name="Text" label="Text"></v-textarea> -->
          </v-layout>
        </v-container>
        <!-- <v-btn icon class="left mr-0 pr-0" xs12 @click="dropzone.processQueue()"><v-icon>send</v-icon></v-btn> -->
        <v-flex class="pl-3 pb-3">
          <v-btn @click="save_text">save</v-btn>
          <v-btn @click="showUpload = !showUpload">cancel</v-btn>
        </v-flex>
      </v-flex>
    </div>

    <!-- edit form -->
    <v-dialog v-model="edit_dialog" width="80%">
      <!-- <v-btn class="right primary mt-4 mr-3 mb-0 xs12" v-if="edit_dialog" @click="edit_dialog=!edit_dialog">close</v-btn> -->
      <v-card elevation-2 mx-3 mt-4>
        <v-container grid-list-xs fluid>
          <v-layout row wrap>
            <v-text-field
              v-model="edited_text.title"
              class="flex xs12 ml-2"
              name="Title"
              label="Title"
            ></v-text-field>
            <text-editor
              @input="edited_text.content = $event"
              :value="edited_text.content"
            ></text-editor>
            <!-- <v-textarea v-model="edited_text.content" auto-grow  class="flex xs12 ml-2" name="Text" label="Text"></v-textarea> -->
          </v-layout>
        </v-container>
        <!-- <v-btn icon class="left mr-0 pr-0" xs12 @click="dropzone.processQueue()"><v-icon>send</v-icon></v-btn> -->
        <v-flex class="pl-3 pb-3 text-xs-right">
          <v-btn @click="edit_dialog = !edit_dialog" class="mr-4">cancel</v-btn>
          <v-btn dark right @click="save_edited_text">save</v-btn>
        </v-flex>
      </v-card>
    </v-dialog>

    <!-- <h3
      class="pl-3 pt-3 pb-0 mb-0"
      v-if="this.local_artwork.artwork_texts && this.local_artwork.artwork_texts.length>0"
    >Other Texts</h3> -->

    <v-container
      class="my-0 mx-0 px-0 py-0"
      fluid
      v-if="
        this.local_artwork.artwork_texts &&
        this.local_artwork.artwork_texts.length > 0
      "
    >
      <v-layout class="my-0 mx-2 px-0 py-0" row wrap>
        <v-card
          v-for="p in this.local_artwork.artwork_texts"
          :key="p.id"
          class="my-2 mx-2"
          elevation-0
          style="width: 100%"
        >
          <v-card-title class="pb-0 mb-0">
            <span class="headline" v-html="p.title"></span>
          </v-card-title>
          <v-card-text v-html="p.content" class="py-0 my-0 bio"></v-card-text>
          <v-card-actions class="mx-0 mt-3">
            <v-chip class="ml-2" small v-if="p.publication">publication</v-chip>
            <v-chip class="ml-2" small v-if="p.article">article</v-chip>
            <v-chip class="ml-2" small v-if="p.artwork_text"
              >text on artwork</v-chip
            >
            <v-chip class="ml-2" small v-if="p.artist_documents"
              >artist documents</v-chip
            >
            <v-chip class="ml-2" small v-if="p.pr">PR</v-chip>
            <v-chip class="ml-2" small v-if="p.transcript">transcript</v-chip>
            <v-chip class="ml-2" small v-if="p.work_text">work text</v-chip>
          </v-card-actions>
          <v-card-actions class="mx-2">
            <small class="ml-1"
              >CREATED: <b>{{ format_date(p.created_at) }}</b></small
            >
            <small class="ml-4" v-if="p.written_by"
              >WRITTEN BY: <b>{{ get_abb(p.written_by) }}</b></small
            >
            <small class="ml-4" v-if="p.created_by"
              >CREATED BY: <b>{{ get_abb(p.created_by) }}</b></small
            >
            <small class="ml-4"
              >LAST UPDATE: <b>{{ format_date(p.updated_at) }}</b></small
            >
            <v-spacer></v-spacer>
            <v-btn @click="copy2c(p.content)" small icon>
              <v-icon small>file_copy</v-icon>
            </v-btn>
            <v-btn @click="download_text(p)" small icon class="mr-1">
              <v-icon small color="black">mdi-download</v-icon>
            </v-btn>
            <v-btn
              @click="edit_text(p)"
              small
              icon
              class="mr-0"
              v-if="c_user.edit"
            >
              <v-icon small>edit</v-icon>
            </v-btn>
            <v-btn
              @click="delete_text(p)"
              small
              icon
              v-if="c_user.delete_rights"
            >
              <v-icon color="red" small>delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import axios from '../../../static/axios.js'
// import * as clipboard from "clipboard-polyfill/text";
import Upload from './Upload'
import TextEditor from './TextEditor'

// async function copy2c2(t) {
//   console.log('Previous clipboard contents:', clipboard.read())
//   async function handler() {
//     console.log('Previous clipboard contents:', await clipboard.read())

//     const item = new clipboard.ClipboardItem({
//       'text/html': new Blob(
//         ['<i>Markup</i> <b>text</b>. Paste me into a rich text editor.'],
//         { type: 'text/html' }
//       ),
//       'text/plain': new Blob(
//         ['Fallback markup text. Paste me into a rich text editor.'],
//         { type: 'text/plain' }
//       ),
//     })
//     await clipboard.write([item])
// }
// }

export default {
  props: {
    artwork: Object,
    no_upload: Boolean,
    category: String,
    add_text: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    // editor: null,
    local_artwork: {},
    edit_dialog: false,
    bibliography_details: '',
    edit_bio_dialog: false,
    edited_text: Object,
    show: false,
    showUpload: false,
    artwork_texts: [],
    text: {
      content: '',
      title: '',
      category: '',
      artwork_id: '',
    },
  }),
  watch: {
    artwork: function () {
      // console.log('text artwork updated');
      this.local_artwork = this.artwork
      this.artwork_texts = this.local_artwork.artwork_texts
    },
  },
  mounted() {
    this.local_artwork = this.artwork
    this.artwork_texts = this.local_artwork.artwork_texts
  },
  // mounted() {
  //   this.editor = this.editor
  //  Editor({
  //   content: '<p>This is just a boring <b>paragraph</b></p>',
  // })
  // },
  computed: {
    // c_user() {
    //   return this.$store.state.user.profile;
    // }
    // visa_status () {
    //   this.constants.VISA_STATUSES.find(this.artwork.visa_status)
    // },
    // all_texts () {
    // console.log(this.$store.getters)
    // if (this.category) {
    //   return this.$store.getters.texts.filter(t => t.category == this.category)
    // } else {
    //   return this.$store.getters.texts
    // }
    // },
    // selection_items () {
    //   var artwork_locations = Object.assign([],this.$store.state.locations)
    //   return artwork_locations.sort(dynamicSort('name'))
    // },
    // artwork_texts () {
    //   //  out = this.all_texts.filter(t => { return this.artwork.id==t.artwork_id})
    //   // return out
    //   if (this.artwork.artwork_texts) {
    //     var out = this.artwork.artwork_texts
    //   } else {
    //     var out = []
    //   }
    //   return out
    // }
  },
  methods: {
    // copyToClipboard() {
    //   this.$refs.generator.focus();
    //   document.execCommand('copy');
    //   this.$buefy.toast.open('Copied!');
    // },

    copy2c(text) {
      var tempDivElement = document.createElement('div')

      // Set the HTML content with the given value
      tempDivElement.innerHTML = text

      // Retrieve the text property of the element
      var tt = tempDivElement.textContent || tempDivElement.innerText
      // copy2c2()
      // console.log(text)
      // const listener = function (ev) {
      //   console.log(ev)
      //   ev.preventDefault()
      //   ev.clipboardData.setData('text/html', text)
      //   // ev.clipboardData.setData('text/plain', text)
      // navigator.clipboard.writeText(ev.clipboardData)
      // }
      navigator.clipboard.writeText(tt)
      // document.addEventListener('copy', listener)
      // document.execCommand('copy')

      // document.removeEventListener('copy', listener)
    },
    // const item = new clipboard.ClipboardItem({
    //     "text/html": new Blob(
    //       [t],
    //       { type: "text/html" }
    //     ),
    //     "text/plain": new Blob(
    //       [t],
    //       { type: "text/plain" }
    //     ),
    //   });
    //   clipboard.write([item]);
    // navigator.clipboard.writeText(t).then(
    //   function() {
    //     // console.log('Async: Copying to clipboard was successful!');
    //   },
    //   function(err) {
    //     console.error("Async: Could not copy text: ", err);
    //   }
    // );
    // },
    download_text(text) {
      // console.log(text)
      // this.exportHTML(text, this.artwork)
      this.exportHTML(text.content, text.title)
    },
    delete_text(t) {
      // console.log(this.artwork.artwork_texts)
      axios
        .delete(`${this.$globals.apiserver}/artwork_texts/${t.id}.json`, {
          id: t,
        })
        .then((response) => {
          this.errors = {}
          this.$store.commit('REMOVE_TEXT', t)
          this.local_artwork.artwork_texts = this.artwork.artwork_texts.filter(
            (at) => {
              return at.id != t.id
            }
          )
          this.$emit('getArtwork')
          // console.log(this.artwork.artwork_texts)
        })
        .catch((error) => {
          this.errors = error.response.data
        })
    },
    edit_text(et) {
      this.edit_dialog = true
      this.edited_text = Object.assign(
        {},
        this.artwork.artwork_texts.find((at) => at.id == et.id)
      )
    },
    edit_bio() {
      this.edit_bio_dialog = true
      this.bibliography_details = this.artwork.bibliography_details
    },
    save_bio(a) {
      this.$emit('showSnackbar', 'Saving bio … ')
      // setTimeout(() => {
      let url = `${this.$globals.apiserver}/artworks/${this.artwork.id}.json`
      axios
        .put(url, {
          field_name: 'bibliography_details',
          field_value: this.bibliography_details,
          updated_by: this.c_user.id,
        })
        .then((response) => {
          this.edit_bio_dialog = false
          this.$emit('showSnackbar', 'Bio saved.', 'green')
          this.$emit('getArtwork')
        })
        .catch((error) => {
          this.$emit(
            'showSnackbar',
            'Error Saving  ' + this.f_field.name,
            'red'
          )
        })
      // }, 1000);
    },
    save_edited_text() {
      this.edited_text.artwork_id = this.artwork.id
      this.edited_text.category = 'artwork_text'
      axios
        .put(
          `${this.$globals.apiserver}/artwork_texts/${this.edited_text.id}.json`,
          {
            artwork_text: this.edited_text,
          }
        )
        .then((response) => {
          this.errors = {}
          // this.$store.commit('REMOVE_TEXT', this.edited_text)
          // console.log('then')
          // console.log(this.artwork.artwork_texts)
          this.artwork.artwork_texts = this.artwork.artwork_texts.filter(
            (at) => {
              return at.id != response.data.id
            }
          )
          // console.log(this.artwork.artwork_texts)
          this.artwork.artwork_texts.push(response.data)
          // console.log(this.artwork.artwork_texts)
          // this.$store.commit('ADD_TEXT', this.edited_text)
          this.edit_dialog = false
          this.edited_text = Object
        })
        .catch((error) => {
          // console.log("error");
          // this.errors = error.response.data;
        })
      this.edited_text = {
        content: '',
        title: '',
        category: '',
        artwork_id: '',
      }
    },
    save_text() {
      this.text.artwork_id = this.artwork.id
      // if (!this.artwork.artwork_texts) {
      //   this.artwork.artwork_texts = []
      // }
      // this.all_texts.push(this.text)
      // console.log(this.text);
      axios
        .post(`${this.$globals.apiserver}/artwork_texts.json`, {
          artwork_text: this.text,
        })
        .then((response) => {
          this.errors = {}
          this.local_artwork.artwork_texts = response.data
          // this.active_texts = this.artwork.artwork_texts
          this.$store.commit('ADD_TEXT', response.data)
          this.showUpload = !this.showUpload
          // this.active_todos.push(response.data);
          // this.todos.push(response.data);
        })
        .catch((error) => {
          this.errors = error.response.data
        })
      this.text = {
        content: '',
        category: '',
        title: '',
        artwork_id: '',
      }
      // var atodo = Object.keys(this.text).forEach(k => this.text[k]='')
      // console.log(atodo)
    },
    // save () {
    //   this.text.artwork_id = this.artwork.id
    //   this.text.id = this.findMinMax(this.all_texts)+1
    //   this.$store.commit('ADD_TEXT', this.text)
    //   // this.artwork_texts.push(this.text)
    //   // console.log(this.text)
    //   // this.all_texts.push(this.text)
    //   this.showUpload=!this.showUpload
    //   this.text = {
    //   text: '',
    //     content: '',
    //     title: '',
    //     artwork_id: ''
    //   }
    // },
    // findMinMax(arr) {
    //   let max = arr[0].id
    //   for (let i = 1, len=arr.length; i < len; i++) {
    //     let v = arr[i].id
    //     max = (v > max) ? v : max
    //   }
    //   return max
    // }
  },
  components: { TextEditor, Upload },
}
</script>

<style>
/* .card {
  min-width: 250px;
} */
.bio p {
  font-size: 16px;
  padding: 10px 0px 0px 0px !important;
  margin-bottom: 0px !important;
  line-height: 1.2;
}
p {
  font-size: 16px;
  padding: 1px 0px 0px 0px !important;
  line-height: 1.2;
}
</style>



// WEBPACK FOOTER //
// src/components/artworks/Texts.vue